import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../services/httpService";
import messagePopup from "../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_SCHOOL_TYPE_LIST_START: "ALL_SCHOOL_TYPE_LIST_START",
  ALL_SCHOOL_TYPE_LIST_SUCCESS: "ALL_SCHOOL_TYPE_LIST_SUCCESS",
  ALL_SCHOOL_TYPE_LIST_FAILED: "ALL_SCHOOL_TYPE_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const allSchoolTypeListStart = (data) => ({
  type: actionType.ALL_SCHOOL_TYPE_LIST_START,
  payload: data,
});

export const allSchoolTypeListSuccess = (data) => ({
  type: actionType.ALL_SCHOOL_TYPE_LIST_SUCCESS,
  payload: data,
});

export const allSchoolTypeListFailed = (data) => ({
  type: actionType.ALL_SCHOOL_TYPE_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allSchoolTypeListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_SCHOOL_TYPE_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_SCHOOL_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.ALL_SCHOOL_TYPE_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* allSchoolTypeListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        allSchoolTypeListSuccess({
          allSchoolTypes: response.data.data.allSchooltypes,
        })
      );
    } else {
      messagePopup("", "School Type List failed", "error");
      yield put(allSchoolTypeListFailed("School Type List failed"));
    }
  } catch (error) {
    messagePopup("", "School Type List failed", "error");
    yield put(allSchoolTypeListFailed("School Type List failed"));
  }
}

//Watcher
export function* watchAllSchoolTypeListSaga() {
  yield takeEvery(actionType.ALL_SCHOOL_TYPE_LIST_START, allSchoolTypeListSaga);
}
